/* CircleDate.jsx */
import React, { forwardRef, useContext } from 'react'
import { AuthContext } from '../../../contexts/AuthContext'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import './stylesDC.css'

const CircleDate = forwardRef(({ dia, onClick, selected, disabled = false }, ref) => {
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { getCurrentDay } = useContext(EmpresasContext)

  // 1) Obtém o "hoje" corrigido (server ou local)
  const currentDay = getCurrentDay()

  // 2) Verifica se 'dia' está dentro do intervalo [currentDay, currentDay + 364 dias]
  //    — ou seja, dia >= currentDay (no mesmo dia ou dia futuro) E dia <= currentDay + 364
  const limiteMax = currentDay.clone().add(364, 'days').endOf('day')
  const valid =
    dia.clone().startOf('day').isSameOrAfter(currentDay.clone().startOf('day')) &&
    dia.clone().startOf('day').isSameOrBefore(limiteMax, 'day')

  return (
    <div className='contain-btt-day-cyrcle'>
      <button
        title={valid ? dia.format('DD/MM/YYYY') : 'Dia indisponível'}
        className={
          selected
            ? 'btt-day-cyrcle-sel'
            : valid && !disabled
              ? 'btt-day-cyrcle'
              : 'btt-day-cyrcle-invalid'
        }
        onClick={() => {
          if (valid && !disabled) {
            onClick()
          }
        }}
        ref={ref}
      >
        {sttAuthCtx.width < 768 && (
          <h4 style={{ fontSize: '9px' }}>{dia.format('ddd').toUpperCase()}</h4>
        )}
        <h3>{dia.format('DD')}</h3>
        {sttAuthCtx.width > 767 && <h3>{dia.format('ddd').toUpperCase()}</h3>}
      </button>
    </div>
  )
})

CircleDate.displayName = 'CircleDate'
export default CircleDate
